/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaInputWithLabelField from 'DesignSystem/TysiaInputWithLabelField/index'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/CreateProcedureReceivables/NewTask/Content/Title",
  onChange
  
}) {
let eventActionDataNewTaskTitleValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.new_task.title',
})
let eventActionDataNewTaskTitleChangeData = fromData.useDataChange({ viewPath,
context: 'event_action',
path: 'data.new_task.title',
})
  return (<React.Fragment
>
<TysiaInputWithLabelField
  viewPath={`${viewPath}/TysiaInputWithLabelField`}
 data="event_action.data.new_task.title"
 value={eventActionDataNewTaskTitleValueData}
 onChange={eventActionDataNewTaskTitleChangeData}
 required={true}
 marginTop={0}
 marginBottom={0}
 width="100%"
 label="Title"
 placeholder="Schedule online appointment"
/>
{children}
</React.Fragment>)
}